import React from 'react';
import logo from './logo.svg';
import './App.css';
import cryingDataset from './crying_dataset.json';
import {Block, Row, Col, Inline} from 'jsxstyle';
import whiteStar from './whiteStar.svg'
import blackStar from './blackStar.svg'
import icon from './default.png'


const dataLens = cryingDataset.number_of_reviews;

function grabThreeRandom(){
  var res = [];
  for(var i = 0; i < 3; i++) {
    var rand = Math.floor(Math.random() * dataLens);
    res.push(cryingDataset.reviews[rand]);
  }
  return res;
}

function getSadIdx(body){
  var sadIdx = body.indexOf("cry");
  if(sadIdx == -1){
    sadIdx = body.indexOf("CRY")
  } 
  if(sadIdx == -1){
    sadIdx = body.indexOf("tear")
  }
  if(sadIdx == -1){
    sadIdx = body.indexOf("TEAR")
  }
  if (sadIdx == -1){
    sadIdx = body.indexOf("sob")
  }
  if (sadIdx == -1){
    sadIdx = body.indexOf("SOB")
  } 
  return sadIdx;
}

function getEndIdx(text, sadIdx){
  var endIdx1 = text.indexOf(" ", sadIdx);
  endIdx1 = endIdx1 < 0 ? 10000 : endIdx1;

  var endIdx2 = text.indexOf(".", sadIdx);
  endIdx2 = endIdx2 < 0 ? 10000 : endIdx2;

  var endIdx3 = text.indexOf(",", sadIdx);
  endIdx3 = endIdx3 < 0 ? 10000 : endIdx3;

  var endIdx4 = text.indexOf(")", sadIdx);
  endIdx4 = endIdx4 < 0 ? 10000 : endIdx4;

  var endIdx = Math.min(endIdx1, Math.min(endIdx2, Math.min(endIdx3, endIdx4)))
  if(endIdx < 0) endIdx = text.length;
  return endIdx;
}

function Review(props){
  var ele = props.ele;
  var date = ele.date;
  var stars = ele.stars;
  var title = ele.review_title;
  var windowWid = props.windowWid;

  var bodyElement;
  var titleElement;

  var body = ele.review_body;

  var sadIdx = getSadIdx(body);

  if (sadIdx == -1){
    var sadIdx = getSadIdx(title);
    var endIdx = getEndIdx(title, sadIdx);
    var beforeSad = title.substring(0, sadIdx);
    var sadWord = title.substring(sadIdx, endIdx);
    var afterSad = title.substring(endIdx, title.length);
    titleElement = ( <Block><Inline>{beforeSad}</Inline>
                        <Inline className="rainbow-text">{sadWord}</Inline>
                        <Inline>{afterSad}</Inline></Block>)
    bodyElement = body;
  } else {
    var endIdx = getEndIdx(body, sadIdx);
    var beforeSad = body.substring(0, sadIdx);
    var sadWord = body.substring(sadIdx, endIdx);
    var afterSad = body.substring(endIdx, body.length);
    bodyElement = ( <Block><Inline>{beforeSad}</Inline>
                        <Inline className="rainbow-text">{sadWord}</Inline>
                        <Inline>{afterSad}</Inline></Block>)
    titleElement = title;
  }
  
  if(windowWid < 800){
    return (
      <Col key={props.idx} borderTop={"1px solid rgba(0, 0, 0, 0.1)"} padding="24px">
        <Row minWidth="200px" height="100%" paddingRight="48px">
          <Block component={"img"} width="40px" height="40px" props={{"src": icon}}></Block>
          <Block filter="blur(3px)" marginLeft="24px">{ele.userid%100000}</Block>
        </Row>
        <Col maxWidth="800px">
          <Stars number={stars}/>
          <Block fontWeight="800" marginBottom="8px">{titleElement}</Block>
          <Block>{bodyElement}</Block>
        </Col>
      </Col>
    );
  } else {
    return (
      <Row key={props.idx} borderTop={"1px solid rgba(0, 0, 0, 0.1)"} padding="24px">
        <Row minWidth="200px" height="100%" paddingRight="48px">
          <Block component={"img"} width="40px" height="40px" props={{"src": icon}}></Block>
          <Block filter="blur(3px)" marginLeft="24px">{ele.userid%100000}</Block>
        </Row>
        <Col maxWidth="700px">
          <Stars number={stars}/>
          <Block fontWeight="800" marginBottom="8px">{titleElement}</Block>
          <Block>{bodyElement}</Block>
        </Col>
      </Row>
    )
  }
}

function Stars(props){
  var number = parseInt(props.number.substring(0, 1));
  var final = [];
  for(var i = 0; i < 5; i ++){
    final.push(i < number);
  }
  return (<Block marginBottom="8px">{final.map(b => (<Star star={b}/>))}</Block>);
}

function Star(props){
  if(props.star) 
    return (<img src = {blackStar}/>);
  else 
    return (<img src={whiteStar}/>);
}

class App extends React.PureComponent {
  constructor(props){
    super(props)
    this.state = {reviews: grabThreeRandom()}
    this.changeReviews = this.changeReviews.bind(this);
  }
  
  changeReviews(){
    this.setState({reviews: grabThreeRandom()});
  }

  render(){
    var three = this.state.reviews;
    var windowWid = document.getElementsByTagName("BODY")[0].clientWidth;
    return (
      <Col alignItems="center" minHeight="calc(100% - 96px)" padding={windowWid < 800 ? "24px" : "48px"}>
        <Block component="img" width="300px" props={{src:logo}} marginBottom="8px"/>
        <Col backgroundColor="white" paddingLeft={windowWid < 800 ? "12px" : "48px"} paddingRight={windowWid < 800 ? "12px" : "48px"}>
          <Block textAlign="center" fontFamily="georgia" fontSize="24px" marginBottom="24px">Ratings and Reviews</Block>
          {three.map((ele, i) => (
            <Review ele={ele} idx={i} windowWid={windowWid}/>
          ))}
        </Col>
        <Block position="fixed" right="10%" bottom="10%" userSelect="none" background="white" borderRadius="4px" border="1px solid black"
        props={{onClick: this.changeReviews}} hoverCursor="pointer" textDecoration="underline" padding="20px">load different reviews</Block>
      </Col>
    );
  }
}

export default App;
